import { ApiError, ApiResponse, ENDPOINTS, apiInstance } from '@/shared/api';
import type { PostPresignedUrlRequest } from '@/shared/api';

export async function issuePresignedUrl(count: number) {
  const url = ENDPOINTS.common.presignedUrls();
  const res = await apiInstance.post<ApiResponse<PostPresignedUrlRequest>>(
    url,
    { count },
  );
  if (!res.data) throw new Error('사전 서명 URL 발급에 실패했습니다.');
  return res.data;
}

export async function uploadToS3WithPutPresignedUrl(params: {
  presignedUrl: string; // BE가 준 업로드용 presigned URL
  file: Blob;
  contentType?: string; // BE에서 presigned url 생성시 지정한 ContentType
  signal?: AbortSignal;
}) {
  const { presignedUrl, file, signal } = params;
  const body = await file.arrayBuffer();
  const res = await fetch(presignedUrl, {
    method: 'PUT',
    body: body,
    signal,
  });

  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new ApiError(text, res.status, 'S3_001');
  }

  return true;
}

/**
 * 단건 파일을 S3에 업로드하고 객체 key를 반환.
 * issuePresignedUrl(1) + uploadToS3WithPutPresignedUrl 두 호출을 한 번에 처리하는 헬퍼 —
 * 단건 추가 흐름(예: banner-editor 이미지 추가)에서 보일러플레이트 제거.
 */
export async function uploadFileToS3(
  file: Blob,
  opts?: { signal?: AbortSignal },
): Promise<{ key: string }> {
  const presignedList = await issuePresignedUrl(1);
  const presigned = presignedList[0];
  if (!presigned) {
    throw new ApiError('presigned URL 응답이 비어있습니다', 0, 'S3_002');
  }
  await uploadToS3WithPutPresignedUrl({
    presignedUrl: presigned.presigned_url,
    file,
    signal: opts?.signal,
  });
  return { key: presigned.key };
}
